import { FC } from 'react'
import { useHistory } from 'react-router-dom'

import { Title, Text, Button, Icon } from '../../components/UI'

const RegisterFormSuccess:FC<{ buttonText?: string, wrapper?: boolean }> = ({ children, buttonText = 'IR A MI PORTAL INDISA', wrapper = false })  => {
  const history = useHistory()

  return (
    <div className="text-center pt-40 pb-50 px-15">
      <Icon name="modal-success" />
      <Title component="h4" size="20" weight="bold" className="mt-25">¡Registro exitoso!</Title>
      <div className={`mt-20 ${wrapper ? 'register-form-modal-wrapper' : ''}`}>
        <Text lineHeight="6">{children}</Text>
      </div>
      <Button className="mt-30" onClick={() => history.push('/')}>{buttonText}</Button>
    </div>
  )
}

export { RegisterFormSuccess }